import { GroupFilesHubFREState } from '../Schema/GroupFilesHubFREState';
import { createStore } from 'satcheljs';

const initialStore: GroupFilesHubFREState = {
    shouldShowFRECallouts: false,
    shouldShowRecentFilesCallout: false,
    spCalloutShown: false,
    recentFilesCalloutShown: false,
};

export const getGroupFilesHubFREStore = createStore<GroupFilesHubFREState>(
    'GroupFilesHubFREStore',
    initialStore
);
